import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import { AIFormattedText } from '../components/AIFormattedText';
import Loading from '../components/Loading';
import FileUploader from '../components/FileUploader';
import ConsoleLogs from '../components/ConsoleLogs';
import { formatTimeStamp } from '../utils/Helpers';
import { useTakeOffs } from '../context/TakeOffContext';
import axios from 'axios';
import ImageMagnifier from '../components/ImageMagnifier';
import SheetTakeOff from '../components/SheetTakeOff';
import PrintSheetTakeOff from '../components/PrintSheetTakeOff';

function TakeOff() {
  const { takeOffs, loading, submitNewTakeoff, updateTakeoff, addToOrders: contextAddToOrders } = useTakeOffs();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [waitingOpenAI, setWaitingOpenAi] = useState(true)
  const [serverResponse, setServerResponse] = useState({});
  const [textResponse, setTextResponse] = useState('');
  const [sidebar, setSidebar] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedJobsite, setSelectedJobsite] = useState(null);
  const [showOriginal, setShowOriginal] = useState(true)
  const [showSheet, setShowSheet] = useState(false)
  const [formData, setFormData] = useState({
    company: '',
    jobsite: '',
    contact: '',
    tel: '',
    deliveryDate: ''
  });
  const [products, setProducts] = useState({
    Frames_6Hx4W: 0,
    Frames_5Hx4W: 0,
    Frames_4Hx4W: 0,
    Frames_inBox: 0,
    U_Heads: 0,
    Base_Plate: 0,
    Cross_Bars: 0,
    Shores: 0,
    Shores_sub: 0,
    Frames_slab:0,
    Frames_band:0
  });

  const handleResponse = (data) => {
      setServerResponse(data);
      setTextResponse(data.extracted_text);
      setWaitingOpenAi(false)
      setSidebar(false);
      setHasSubmitted(false); // Reset submission flag
  };


  const makeProductList = (objects) => {
    setProducts({
      // Frames_6Hx4W: objects.frames_6x4 * 2,
      Frames_slab: objects.total_6x4 - objects.underSlab_6x4,
      Frames_band: objects.underSlab_6x4,
      Frames_5Hx4W: objects.frames_5x4 * 2,
      Frames_4Hx4W: 0,
      Frames_inBox: objects.frames_In_Box * 2,
      U_Heads: (objects.frames_6x4 + objects.frames_5x4 + objects.frames_In_Box) * 2,
      Base_Plate: (objects.frames_6x4 + objects.frames_5x4 + objects.frames_In_Box) * 2,
      Cross_Bars: (objects.frames_6x4 + objects.frames_5x4 + objects.frames_In_Box) * 2,
      Shores_sub: objects.shores_Box,
      Shores: Math.floor((objects.shores - (objects.shores_Box * 4)) / 6),
      
    });
  };

  const handleSubmitTakeoff = async () => {
    let takeoffData = {
      created_at: new Date().toISOString(),
      company: selectedCompany,
      jobsite: selectedJobsite,
      data: {
        products: serverResponse.objects,
        information: serverResponse.extracted_text,
        fileName: serverResponse.file_name, 
        fileSize: (serverResponse.file_size / (1024 * 1024)).toFixed(2), 
        originalDrawing: serverResponse.original_drawing,
        modifiedDrawing: serverResponse.modified_drawing, 
      },
    };

    console.log('SAVING TAKEOFF :');
    await submitNewTakeoff(takeoffData);
  };

  const renderProductList = () =>
    Object.entries(products).map(([key, value]) => (
      <div
        key={key}
        className="flex flex-row justify-between border-b border-gray-700 px-5 py-3 hover:bg-gray-700"
      >
        <b>{key.replace(/_/g, ' ')}:</b>
        <p>{value}</p>
      </div>
    ));

  useEffect(() => {
      if (
        serverResponse &&
        serverResponse.objects &&
        selectedCompany &&
        selectedJobsite &&
        !hasSubmitted &&
        !serverResponse.id // Only submit new takeoff if there's no ID (it's a new takeoff)
      ) {
        // const scaffolds = serverResponse.objects.frames_6x4 || 0;
        // const shores = serverResponse.objects.shores || 0;
        // const objects = serverResponse.colorObjects
        makeProductList(serverResponse.objects);
    
        // Submit and prevent further submissions
        handleSubmitTakeoff();
        setHasSubmitted(true);
      }
   }, [serverResponse, selectedCompany, selectedJobsite]);

   const handleTakeoffClick = (takeoff) => {
    console.log('Takeoff clicked:', takeoff);
    // Log the takeoff ID for debugging
    console.log('Takeoff ID:', takeoff.id, 'Type:', typeof takeoff.id);
    
    // Ensure the takeoff data structure matches what the component expects
    setServerResponse({
      ...takeoff,
      id: takeoff.id, // Ensure ID is explicitly set
      file_name: takeoff.data.fileName || '',
      file_size: parseFloat(takeoff.data.fileSize || '0') * 1024 * 1024, // Convert to bytes for consistency
      original_drawing: takeoff.data.originalDrawing || '',
      modified_drawing: takeoff.data.modifiedDrawing || '',
      objects: takeoff.data.products || {},
      extracted_text: takeoff.data.information || ''
    });

    setTextResponse(takeoff.data.information || '');
    
    // Set company and jobsite selections
    setSelectedCompany(takeoff.company || '');
    setSelectedJobsite(takeoff.jobsite || '');
    
    // Set form data
    setFormData({
      company: takeoff.company.toUpperCase() || '',
      jobsite: takeoff.jobsite.toUpperCase() || '',
      contact: takeoff.contact || '',
      tel: takeoff.tel || '',
      deliveryDate: takeoff.deliveryDate || ''
    });
    
    // Make product list from objects
    if (takeoff.data?.products) {
      makeProductList(takeoff.data.products);
    }
    
    // Update UI state
    setSidebar(false);
    setShowOriginal(true);
    setWaitingOpenAi(false);
  }
      
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSave = async () => {
    if (!serverResponse.id) {
      alert('No takeoff selected to update');
      return;
    }
    
    try {
      // Log the original ID for debugging
      console.log('Original ID:', serverResponse.id, 'Type:', typeof serverResponse.id);
      
      // Ensure ID is correctly formatted
      const id = parseInt(serverResponse.id);
      
      if (isNaN(id) || id <= 0) {
        alert('Invalid ID format');
        return;
      }
      
      const updateData = {
        id: id,
        created_at: serverResponse.created_at,
        deliveryDate: formData.deliveryDate || new Date().toISOString().split('T')[0],
        company: formData.company || selectedCompany,
        jobsite: formData.jobsite || selectedJobsite,
        contact: formData.contact || '',
        tel: formData.tel || ''
      };
      
      // Log the final request data for debugging
      console.log('UPDATE REQUEST:', JSON.stringify(updateData, null, 2));
      
      // If these are present, include them in a separate update for the data field
      if (formData.contact || formData.tel) {
        // This would need an additional API endpoint to handle data field updates
        console.log('Contact/Tel data:', { contact: formData.contact, tel: formData.tel });
      }
      
      // Use the context method instead of direct axios call
      const result = await updateTakeoff(updateData);
      
      if (result.success) {
        alert('Takeoff updated successfully');
      } else {
        alert(`Failed to update takeoff: ${result.message}`);
      }
    } catch (error) {
      console.error('Error updating takeoff:', error);
      alert(`Error updating takeoff: ${error.message}`);
    }
  };

  const addToOrders = async () => {
    try {
      // Prepare the data object to match API requirements
      const orderData = {
        company: formData.company || selectedCompany,
        jobsite: formData.jobsite || selectedJobsite,
        contact: formData.contact || '',
        tel: formData.tel || '',
        date: formData.deliveryDate || new Date().toISOString().split('T')[0],
        
        // Map product fields to API expected fields
        af6x4: products.Frames_6Hx4W || 0,
        af5x4: products.Frames_5Hx4W || 0,
        af4x4: products.Frames_4Hx4W || 0,
        sf6x4: products.Frames_6Hx4W || 0, // Matching steel frames 
        sf5x4: products.Frames_5Hx4W || 0, // Matching steel frames
        sf4x4: products.Frames_inBox || 0, // Matching steel frames
        sf3x4: products.sf3x4 || 0,
        
        // Cross bars
        cb10x4: products.cb10x4 || 0,
        cb10x2: products.cb10x2 || 0,
        cb7x4: products.cb7x4 || 0,
        cb7x2: products.cb7x2 || 0,
        cb5x4: products.cb5x4 || 0,
        cb5x2: products.cb5x2 || 0,
        cb4x4: products.cb4x4 || 0,
        cb4x2: products.cb4x2 || 0,
        
        // Coupling components
        afc: products.afc || 0,
        sfc: products.sfc || 0,
        bc: products.bc || 0,
        
        // Headers and plates
        auh: products.U_Heads || 0,
        abp: products.Base_Plate || 0,
        suh: products.U_Heads || 0,
        sbp: products.Base_Plate || 0,
        
        // Aluminum beams
        ab20: products.ab20 || 0,
        ab18: products.ab18 || 0,
        ab16: products.ab16 || 0,
        ab14: products.ab14 || 0,
        ab13: products.ab13 || 0,
        ab12: products.ab12 || 0,
        ab11: products.ab11 || 0,
        ab106: products.ab106 || 0,
        ab10: products.ab10 || 0,
        ab9: products.ab9 || 0,
        ab8: products.ab8 || 0,
        ab7: products.ab7 || 0,
        ab6: products.ab6 || 0,
        ab5: products.ab5 || 0,
        ab4: products.ab4 || 0,
        
        // Shores
        sh1: products.sh1 || 0,
        sh2: products.Shores || 0,
        sh3: products.Shores_sub || 0,
        sh4: products.sh4 || 0,
        
        // Wood beams
        wb14: products.wb14 || 0,
        wb12: products.wb12 || 0,
        wb11: products.wb11 || 0,
        wb10: products.wb10 || 0,
        wb9: products.wb9 || 0,
        wb8: products.wb8 || 0,
        wb7: products.wb7 || 0,
        wb6: products.wb6 || 0,
        wb5: products.wb5 || 0,
        wb4: products.wb4 || 0,
        
        // Additional items
        extraA: '',
        extraB: '',
        extraC: '',
        extraD: '',
        extraE: '',
        extra1: 0,
        extra2: 0,
        extra3: 0,
        extra4: 0,
        extra5: 0,
        
        // Additional fields
        drawings: serverResponse?.original_drawing || '',
        
        // Additional specs
        af2x4: products.af2x4 || 0,
        auh40: products.auh40 || 0,
        auhreg: products.auhreg || 0,
        abp40: products.abp40 || 0,
        abpreg: products.abpreg || 0,
        suh36: products.suh36 || 0,
        suh40: products.suh40 || 0,
        suhreg: products.suhreg || 0,
        sbp36: products.sbp36 || 0,
        sbp40: products.sbp40 || 0,
        sbpreg: products.sbpreg || 0,
        sh03: products.sh03 || 0,
        sh04: products.sh04 || 0,
        sh039: products.sh039 || 0,
        sh1b: products.sh1b || 0,
        sh3b: products.sh3b || 0,
        sh4b: products.sh4b || 0,
        sc4x4x4: products.sc4x4x4 || 0,
        
        // Status fields
        added: '',
        ret: '',
        done: '0'
      };

      // Use the context function for adding to orders
      const result = await contextAddToOrders(orderData);
      
      if (result.success) {
        alert(result.message);
        setShowSheet(false);
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error('Error adding to orders:', error);
      alert(`Error adding to orders: ${error.message}`);
    }
  };

  return (
    <div className="wrapper-orders">
      <Sidebar />
      <div className="content">
        <div className="header">
          <h1>TakeOff</h1> 
          <div className='actions'>
            <i className="bi bi-plus-lg plusIcon" onClick={()=>setServerResponse({})}></i>
          </div>
        </div>
        <div
          className={`${
            sidebar
              ? serverResponse?.file_name
                ? 'grid grid-cols-[20%_60%_20%]'
                : 'grid grid-cols-[20%_80%]'
              : serverResponse?.file_name
              ? 'grid grid-cols-[0_70%_30%]'
              : 'grid grid-cols-[0%_100%]'
          } border-t border-gray-700 mt-[20px] h-[calc(100vh-90px)]`}
        >
          {/* Sidebar */}
          <div
            className={`h-[calc(100vh-90px)] overflow-y-scroll border-gray-700 ${
              sidebar ? 'border-r' : ''
            }`}
          >
            {loading ? (
              <p>Loading takeoffs...</p>
            ) : takeOffs.length === 0 ? (
              <p className='mt-[40vh] text-gray-700'>No takeoffs found.</p>
            ) : (
              [...takeOffs]
                .sort((a, b) => parseInt(b.id) - parseInt(a.id)) // Sort by id in descending order (newest first)
                .map((takeoff) => (
                <div
                  key={takeoff.id}
                  className="border-b border-gray-700 p-5 text-left grid grid-cols-[auto_10px] items-center hover:bg-gray-700"
                  onClick={() => {handleTakeoffClick(takeoff)}}
                >
                  <div>
                    <p className='text-[12px]'>
                      <b>Company:</b> {takeoff.company.toUpperCase()}
                    </p>
                    <p className='text-[12px]'>
                      <b>Jobsite:</b> {takeoff.jobsite.toUpperCase()}
                    </p>
                    <p className='text-[12px]'>
                      <b>Delivery Date:</b> {takeoff.deliveryDate}
                    </p>
                    {/* <p>
                      <b>Time Created:</b> {formatTimeStamp(takeoff.created_at)[1]}
                    </p> */}
                  </div>
                  <i className="bi bi-chevron-compact-right"></i>
                </div>
              ))
            )}
          </div>

          {/* File Viewer */}
          <div className="flex items-center justify-center relative p-5">
            <i
              className="bi bi-layout-sidebar absolute top-2 left-5 text-[30px] text-gray-700"
              onClick={() => setSidebar(!sidebar)}
            ></i>
            <i
              className={`bi bi-symmetry-vertical absolute top-2 right-5 text-[30px] text-gray-700 ${showOriginal ? 'text-gray-700' : 'text-primary'} ${serverResponse.modified_drawing ? 'block' : 'hidden'}`}
              onClick={() => setShowOriginal(!showOriginal)}
            ></i>
            {serverResponse?.original_drawing ? (
              <div className={`${!showOriginal ? 'bg-white' : ''}`}>
              <ImageMagnifier src={`${!showOriginal ? serverResponse.original_drawing : serverResponse.modified_drawing}`}/>
              </div>
            ) : (
              <div className="flex flex-col w-full -mt-[150px]">
                <FileUploader 
                  onResponse={handleResponse}
                  onCompanySelect={(company) => setSelectedCompany(company)}
                  onJobsiteSelect={(jobsite) => setSelectedJobsite(jobsite)}
                />
              </div>
            )}
          </div>

          {/* Takeoff Details */}
          {serverResponse?.file_name && (
            <div className="border-l border-gray-700 h-[calc(100vh-90px)] overflow-y-scroll">
              <div className="border-b border-gray-700 p-4 flex justify-between items-center">
                <p><b>Order Sheet:</b></p>
                <div className='flex items-center space-x-[20px] text-[20px]'>
                  <button className='text-gray-400 hover:text-primary' onClick={()=>setShowSheet(true)}> <i className="bi bi-sliders"></i> </button>
                </div>
              </div>
              <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>Company:</b> {selectedCompany.toUpperCase()}
                </p>
              </div>
              <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>Jobsite:</b> {selectedJobsite.toUpperCase()}
                </p>
              </div>
              <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>File Name:</b> {serverResponse.file_name}
                </p>
              </div>
              {/* <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>File Type:</b> {serverResponse.type}
                </p>
              </div> */}
              <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>File Size:</b>{' '}
                  {(serverResponse.file_size / (1024 * 1024)).toFixed(2)} MB
                </p>
              </div>
  
              <div className="border-b border-gray-700 p-4">
                <p className="text-left">
                  <b>Shapes Count:</b>
                </p>
                {products ? renderProductList() : <p>No product data available.</p>}
              </div>
              <div className="border-b border-gray-700 p-4">
                {waitingOpenAI ? (
                  <div className="p-[10px] flex items-center gap-[20px]">
                    <Loading />
                    <p> Thinking ... </p>
                  </div>
                ) : (
                  <>
                    <AIFormattedText text={textResponse} />
                  </>
                )}
              </div>
              {/* <div className="border-b border-gray-700 p-4 ">
                <SheetTakeOff elements={products} scale={sidebar ? 0.5 * 0.6  : 0.5}  company={selectedCompany} jobsite={selectedJobsite} />
              </div> */}
              <div className='flex items-center justify-around gap-[20px]'>
                {serverResponse.objects.output1 && (
                  <a href={serverResponse.objects.output1} target="_blank" rel="noopener noreferrer">
                    <p>Object Count 1</p>
                  </a>
                )}
                {serverResponse.objects.output2 && (
                  <a href={serverResponse.objects.output2} target="_blank" rel="noopener noreferrer">
                    <p>Object Count 2</p>
                  </a>
                )}
              </div>
            </div>
          )}

          <div className={`bg-black/50 w-full h-full absolute top-0 left-0 z-10 flex items-center justify-center  ${showSheet ? 'block' : 'hidden'}`} onClick={()=>setShowSheet(false)}>
            <div className='bg-[#282c34] w-[80vw] h-[90vh] flex items-center justify-center space-x-[50px] p-10' onClick={(e)=>e.stopPropagation()}>
              <div className='w-[60vh] h-full bg-white'>
                <div id="sheet-takeoff-container">
                  <SheetTakeOff 
                    elements={products}  
                    scale={0.6} 
                    company={formData.company || '---'} 
                    jobsite={formData.jobsite || '---'} 
                    contact={formData.contact || '---'} 
                    tel={formData.tel || '---'} 
                    deliveryDate={formData.deliveryDate || new Date().toLocaleDateString()} 
                  />
                </div>
              </div>
              <div className='w-[40%] h-[90%] flex flex-col justify-between '>
                <div className='flex items-center gap-[20px] mb-[50px]'>
                  <button 
                    className='text-gray-600 hover:text-primary py-5 w-full border border-gray-600 hover:border-primary rounded'
                    onClick={addToOrders}
                  > 
                    <i className="text-[40px] bi bi-clipboard-plus"></i>  
                    <p> Add to Orders </p>
                  </button>
                  <PrintSheetTakeOff />
                </div>
                <div className='space-y-[20px]'>
                  <div> 
                    <p className='text-left ml-2 text-[15px] -mb-[8px] bg-[#282c34] relative w-fit px-3 text-primary'> Company Name</p>
                    <input 
                      type='text' 
                      name="company"
                      value={formData.company.toUpperCase()} 
                      onChange={handleInputChange}
                      placeholder={selectedCompany?.toUpperCase() || 'Company Name'} 
                      className='border border-gray-700 bg-transparent p-3 pl-5 w-full rounded outline-none'
                    />
                  </div>
                  <div> 
                    <p className='text-left ml-2 text-[15px] -mb-[8px] bg-[#282c34] relative w-fit px-3 text-primary'> Jobsite Address</p>
                    <input 
                      type='text' 
                      name="jobsite"
                      value={formData.jobsite.toUpperCase()} 
                      onChange={handleInputChange}
                      placeholder={selectedJobsite?.toUpperCase() || 'Jobsite Address'} 
                      className='border border-gray-700 bg-transparent p-3 pl-5 w-full rounded outline-none'
                    />
                  </div>  
                  <div> 
                    <p className='text-left ml-2 text-[15px] -mb-[8px] bg-[#282c34] relative w-fit px-3 text-primary'> Contact Name</p>
                    <input 
                      type='text' 
                      name="contact"
                      value={formData.contact.toUpperCase()} 
                      onChange={handleInputChange}
                      placeholder={'Contact Name'} 
                      className='border border-gray-700 bg-transparent p-3 pl-5 w-full rounded outline-none'
                    />
                  </div>
                  <div> 
                    <p className='text-left ml-2 text-[15px] -mb-[8px] bg-[#282c34] relative w-fit px-3 text-primary'> Tel</p>
                    <input 
                      type='text' 
                      name="tel"
                      value={formData.tel} 
                      onChange={handleInputChange}
                      placeholder={'Tel'} 
                      className='border border-gray-700 bg-transparent p-3 pl-5 w-full rounded outline-none'
                    />
                  </div>
                  <div> 
                    <p className='text-left ml-2 text-[15px] -mb-[8px] bg-[#282c34] relative w-fit px-3 text-primary'> Date </p>
                    <input 
                      type='date' 
                      name="deliveryDate"
                      value={formData.deliveryDate} 
                      onChange={handleInputChange}
                      placeholder='Date' 
                      className='border border-gray-700 bg-transparent p-3 pl-5 w-full rounded outline-none'
                    />
                  </div>
                  <button 
                    onClick={handleSave}
                    className="bg-primary text-darkGray py-2 px-4 rounded hover:bg-transparent hover:text-primary border border-primary transition duration-200 w-full"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TakeOff;
